export const locationChange = (ip: any) => {
  if (typeof window !== "undefined") {
    window.addEventListener("popstate", function (event) {
      console.log("Location changed:", window.location.href, ip);
    });
  }
};
